export const formatCurrency = (amount, includeSymbol = true) => {
  if (amount === undefined || amount === null) return includeSymbol ? "₦0.00" : "0.00";
  
  const formatted = new Intl.NumberFormat('en-NG', {
    style: includeSymbol ? 'currency' : 'decimal',
    currency: 'NGN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return formatted;
};
